<template>
  <li :class="{ checked }">
    <slot />
  </li>
</template>

<script setup>
// Props
const props = defineProps({
  checked: {
    default() {
      return true
    },
    required: false,
    type: Boolean,
  },
})
</script>

<style lang="postcss" scoped>
li {
  @apply flex flex-row items-center text-origin text-winter-green-900 leading-7 list-none font-normal;

  &.checked {
    &:before {
      @apply font-icon w-4 h-4 flex justify-center items-center flex-shrink-0 rounded-full bg-livestorm-blue-100 text-livestorm-blue-700 mr-2 text-xs content-['\e907'];
    }
  }
}
</style>
